/*
 * Copyright (c) 2022.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Pavel Bobylev <pavel.bobylev1988@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangedProductDocument} from './ChangedProductDocument';
import {ChangeProductType} from './ChangeProductType';
import {ChangeTemplateFeatureValue} from './ChangeTemplateFeatureValue';
import {ComparedPair} from './ComparedPair';
import {ComparedPairWithField} from './ComparedPairWithField';
import {IdAndHeader} from './IdAndHeader';
import {ProductChangedPicture} from './ProductChangedPicture';
import {ProductChangeSupplier} from './ProductChangeSupplier';
import {ProductCodeValue} from './ProductCodeValue';
import {YouTube} from './YouTube';

export interface ProductChangeElasticDto {
  id: string;
  userId: number;
  userLogin: string;
  ip: string;
  productId: number;
  versionId?: number;
  createdAt: Date;

  changeType: ChangeProductType;
  supplier: ProductChangeSupplier;

  plainChangesCount: number;
  codesChangesCount: number;
  dictionariesChangesCount: number;
  featureValueChangesCount: number;
  addedPictures: number;
  removedPictures: number;
  addedDocuments: number;
  removedDocuments: number;
  totalChangesCount: number;
  videosChangesCount: number;

  plain: Array<ComparedPairWithField<string, string>>;
  dictionaries: Array<ComparedPairWithField<string, Array<IdAndHeader>>>;
  templateFeatures: Array<ComparedPairWithField<number, Array<ChangeTemplateFeatureValue>>>;
  pictures: ComparedPair<Set<ProductChangedPicture>>;
  videos: ComparedPair<Set<YouTube>>;
  documents: ComparedPair<Set<ChangedProductDocument>>;
  codes: Array<ComparedPairWithField<string, ProductCodeValue>>;
}
